import * as React from "react";
import { Grid, Typography } from "@mui/material";
import { RecordInfo } from "models/ApiModels";
import RecordCreatorInfo from "components/RecordCreatorInfo";
import RecordModifierInfo from "components/RecordModifierInfo";
import { GlobalClassKeys } from "assets/jss/common-styles";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory } from "@fortawesome/pro-solid-svg-icons/faHistory";
import MuiPaper from "components/MuiExtras/MuiPaper";
import classes from 'classnames';
import { RecordUserThumbnail } from "components/RecordUserThumbnail";
import MuiClickable from "components/MuiExtras/MuiClickable";
import { useTranslation } from 'react-i18next';

export interface IRecordAboutProps {
    record: RecordInfo;
    hideCreator?: boolean;
    onShowHistory: () => void;
}

interface IProps extends IRecordAboutProps {
    otherInfo?: React.ReactElement;
}

export const RecordAbout: React.FC<IProps> = (props) => {
    const { t } = useTranslation();

    return (
        <MuiPaper>
            <Grid container spacing={2} >
                <Grid item>
                    <RecordUserThumbnail record={props.record} />
                </Grid>
                <Grid item className={classes([GlobalClassKeys.grow, GlobalClassKeys.alignSelfTop])}>
                    <Typography variant="body2">
                        <MuiMuted variant="dark">
                            {(props.hideCreator == false || props.hideCreator == null)
                                ?
                                    <>
                                        <RecordCreatorInfo user={props.record.creator} date={props.record.creationDate} />
                                        {(props.record.creationDate.valueOf() != props.record.lastUpdateDate.valueOf())
                                            ? <>
                                                <br />
                                                <RecordModifierInfo user={props.record.revisor} date={props.record.lastUpdateDate} />
                                            </>
                                            : ""
                                        }
                                    </>
                                :
                                <>
                                    {(props.record.creationDate.valueOf() != props.record.lastUpdateDate.valueOf())
                                        ? <RecordModifierInfo user={props.record.revisor} date={props.record.lastUpdateDate} />
                                        : <span>{t("Common.RecordInfo.OriginalRecord")}</span>
                                    }
                                </>
                            }

                            {
                                props.otherInfo &&
                                <>
                                    <br />
                                    {props.otherInfo}
                                </>
                            }
                        </MuiMuted>
                    </Typography>
                </Grid>
                <Grid item className={classes([GlobalClassKeys.textCenter, GlobalClassKeys.alignSelfTop])}>
                    <MuiClickable onClick={props.onShowHistory}  >
                        <Typography color="secondary" variant="subtitle2">
                            <FontAwesomeIcon color="info" size="3x" icon={faHistory} />
                            <br />
                            <span>{t("Common.RecordInfo.HistoricText")}</span>
                        </Typography>
                    </MuiClickable>
                </Grid>
            </Grid>
        </MuiPaper>
    );
};